import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AdminIconComponent } from '../../../../../../shared/admin/admin-icon.component';

@Component({
  selector: 'app-release-search',
  standalone: true,
  imports: [FormsModule, AdminIconComponent],
  template: `
    <div class="rn-search">
      <app-admin-icon name="search" [size]="16" class="rn-search__icon" />
      <input
        class="cg-input rn-search__input"
        type="search"
        [placeholder]="placeholder()"
        [ngModel]="value()"
        (ngModelChange)="valueChange.emit($event)"
        [attr.aria-label]="placeholder()"
      />
    </div>
  `,
  styleUrl: './release-search.component.scss',
})
export class ReleaseSearchComponent {
  readonly value = input('');
  readonly placeholder = input('Search releases by version, build, title, date, or content…');
  readonly valueChange = output<string>();
}
